import React from 'react';
import { useNavigate } from 'react-router-dom';
import "./navbar.css";
import { useDispatch } from "react-redux";
import { logout } from '../../actions/auth';
import { useSelector } from "react-redux";

function Navbar({ children }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    // const location = useLocation()

    const user = useSelector((state) => state.authReducer.authData);
    // const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')));
    // console.log("user", user)

    // useEffect(() => {
    //     setUser(JSON.parse(localStorage.getItem('profile')))
    // }, [location])

    const userLogOut = () => {
        dispatch(logout(navigate))
        // dispatch({ type: "LOGOUT" });
        // navigate("/");
        // setUser(null)
    }
    return (
        <div className='navbar'>
            <div className='container'>
                {user ? (
                    <div className="title">Welcome {user.firstName} {user.lastName}</div>
                ) : <div className=''>Welcome User</div>}

                <div className='nav-content' >
                    {children}
                    <button to="/login" className="logout" onClick={userLogOut}>Logout</button>
                </div>
            </div>
        </div>
    )
}

export default Navbar